import _ from 'lodash'
import { SETTING_ID } from '~~/interface/Setting';


export const utilsItemGenKey = function genKey(item: any) {

  //todo :  split  line here
  if ( item.newLine && item.splited) {
    // ชิ้นที่ถูกแยกออกในการกด "แยกรายการ" ครั้งเดียวกันใช้ splitGroup ร่วมกัน
    // จึงรวมกลับเป็นแถวเดียวได้ แม้จะถูกตัดมาจากคนละบรรทัดต้นทาง
    // ของเก่าที่ไม่มี splitGroup ยัง fallback เป็น uuid เหมือนเดิม (หนึ่งชิ้นหนึ่งแถว)
    return `${item.splitGroup || item.uuid}`
  }


  return utilsItemGroupKey(item)
}

// คีย์ที่บอก "เป็นสินค้าตัวเดียวกันไหม" โดยไม่สนว่าถูกแยกออกมาหรือยัง
//
// ต่างจาก utilsItemGenKey ตรงที่ไม่มีสาขา splited ชิ้นที่แยกออกมาแล้วจึงยัง
// ได้คีย์เดียวกับต้นทาง เอาไปใช้จัดให้สองแถวนั้นอยู่ติดกันบนพาเนลได้
export const utilsItemGroupKey = function groupKey(item: any) {
  // dc1 = [mode, value, amount] - ใช้แค่ mode กับ value เป็น key
  // ห้ามใส่ amount (dc1[2]) เพราะมันผันตาม qty ของแต่ละบรรทัด
  // (ลด 10% จาก 5 ชิ้น กับ จาก 3 ชิ้น ได้ยอดคนละค่า) ถ้าใส่ไปด้วย
  // รายการที่ลดเรตเดียวกันจะไม่รวมแถวกัน ทั้งที่ itemsCombined เขียนโค้ดบวก dc1[2] รอไว้แล้ว
  const discountKey = `${item.dc1?.[0]}:${item.dc1?.[1]}`

  if (item?.options2  && item?.options2?.length > 0) {
    let options = item?.options2?.map((i) => {
      return __optionKeyPart(i)
    })
    return `${item.productId}:${item.comments || ""}:${item.price}:${discountKey}:${options.join(':')}`
  }
  return `${item.productId}:${item.comments || ""}:${item.price}:${discountKey}`
}

export const utilsItemGenKeyInCart = function genKey(item, options2 = null) {
  if (options2) {
    let options = options2?.map((i) => {
      return __optionKeyPart(i)
    })
    return `${item.productId}:${item.comments}:${item.price}:${options.join(':')}`
  }
  return `${item.productId}:${item.comments}:${item.price}`
}

// qty toppings ("qty" type) can be picked more than once, so the quantity is part
// of the identity. qty <= 1 keeps the plain productId so existing keys don't change.
function __optionKeyPart(option: any) {
  const qty = parseInt(option?.qty) || 0
  return qty > 1 ? `${option.productId}x${qty}` : `${option.productId}`
}

export const utilsItemComputeOneTable = function conputeOneTable(tableInstance) {
   
  const roundingType = tableInstance.roundingType || SETTING_ID.ROUNDING_OPTION_NEAREST
  const { subTotal, dc1, sc, dc2, tax, cc, rounding, grandTotal } = utilsItemComputeSummary(tableInstance.items, roundingType)
  
  const g = Math.round((rounding+grandTotal) * 100) / 100
  return {
    subTotal: subTotal,
    dc1: dc1,
    sc: sc,
    dc2: dc2,
    cc:cc,
    tax: tax,    
    rounding: rounding,
    grandTotal: g
  }
}

export const utilsItemComputeSummary = function (items:Array<any>, roundingType:string) {
  //find rounding

  let beforeRounding = [
    __sumChain(items, 'extendedPrice'),
    __sumChain(items, 'dc1'),
    __sumChain(items, 'sc'),
    __sumChain(items, 'dc2'),
    __sumChain(items, 'cc'),
   
  ]

  let tax =  __sumChain(items, 'tax')
  if(tax > 0) { 
    beforeRounding.push(tax)
  }


  // place to 2 decimal
  beforeRounding = beforeRounding.map((item) => {
    return Math.round(item * 100) / 100
  })


  let sumBeforeRounding = beforeRounding.reduce((a, b) => a + b, 0)  
  let rounding = __rounding(sumBeforeRounding, roundingType)

  // rounding place to 2 decimal
  rounding = Math.round(rounding * 100) / 100

  return {
    subTotal: __sumChain(items, 'extendedPrice'),
    dc1: __sumChain(items, 'dc1'),
    sc: __sumChain(items, 'sc'),
    dc2: __sumChain(items, 'dc2'),
    tax: __sumChain(items, 'tax'),
    cc: __sumChain(items, 'cc'),
    rounding,
    grandTotal: sumBeforeRounding , // __sumChain(items, 'amount'), // ไปรวมข้างนแก

  }
}


export const removeEmptyStringAndUndefinedProperties =  function  (obj) {
  for (const key in obj) {
    if (typeof obj[key] === 'object' && obj[key] !== null) {
        // If the property is an object or array (but not null), process it recursively
        removeEmptyStringAndUndefinedProperties(obj[key]);
    } else if (obj[key] === "" || obj[key] === undefined) {
        // If the property is an empty string or undefined, remove it
        delete obj[key];
    }
}
return obj;
}


export const __sumChain = function (items, key) {
  // โต๊ะที่ยังไม่มี/ถูกปิดไปแล้วจะไม่มี items (undefined) ให้ถือว่ายอดเป็น 0
  if (!Array.isArray(items)) {
    return 0
  }
  let l =  items.map((item) => {
    //if array
    let value = 0
    if (Array.isArray(item[key])) {
      value = item[key][2]
    } else {
      value = item[key]
    }
    return value
  })
  
  return l.reduce((a, b) => a + b, 0)
}

//create function rounding  money  (sumBeforeRounding)
function __rounding(total:number, method=SETTING_ID.ROUNDING_OPTION_NEAREST, increment = 1) {
  if (increment <= 0) increment = 1; 

  const ROUNDING_FOMULA = {
    [SETTING_ID.ROUNDING_OPTION_UP]: (Math.ceil(total / increment) * increment)-total,
    [SETTING_ID.ROUNDING_OPTION_DOWN]: -(total-Math.floor(total / increment) * increment),
    [SETTING_ID.ROUNDING_OPTION_NEAREST]: (Math.round(total / increment) * increment) - total,
    [SETTING_ID.ROUNDING_OPTION_NONE]: 0,
  } 

  if( ROUNDING_FOMULA[method] === 0) { 
    return 0
  }


  //Default By Nearest
  return ROUNDING_FOMULA[method] || ROUNDING_FOMULA[SETTING_ID.ROUNDING_OPTION_NEAREST]
}
